import React, { useEffect, useState } from 'react';
import { compose, isEmpty } from 'ramda';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormHelperText from '@material-ui/core/FormHelperText';
import Grid from '@material-ui/core/Grid';
import { Button } from '@deeptrue-frontend/ui';
import { Typography } from '@deeptrue-frontend/ui';
import signInSplash from 'assets/images/sign-in.png';
import RouterProvider from 'components/RouterProvider/RouterProvider';
import { withMetaDescription } from 'components/HeadProvider/HeadProvider';
import { SidePage } from 'components/Layout';
import api from 'api/api';
import { parseErrors } from 'components/Forms/utils';
import { useFormatMessage } from 'components/IntlProvider';

const { Redirect, ROUTES, withRouter } = RouterProvider;

const EmailConfirm = ({ match: { params }, history }: any) => {
  const [isConfirm, setIsConfirm] = useState(false);
  const [error, setError] = useState('');
  const { confirmationKey } = params;
  const t = useFormatMessage();

  const emailConfirmation = (confirmationKey: string) =>
    api.resources
      .confirmEmail({ confirmation_key: confirmationKey })
      .then(() => {
        setIsConfirm(true);
      })
      .catch(({ response }) => {
        const err = parseErrors(response.data);
        setError(err.confirmation_key || err.info);
        setIsConfirm(true);
      });

  useEffect(() => {
    if (confirmationKey) {
      emailConfirmation(confirmationKey);
    }
    // eslint-disable-next-line
  }, []);

  if (!confirmationKey) {
    return <Redirect to={ROUTES.DASHBOARD} />;
  }

  if (!isConfirm) {
    return (
      <SidePage
        title={t('pages.emailconfirm.title', 'Email confirmation')}
        slogan={
          <Typography color="white" variant="h4" mt="8rem">
            {t(
              'pages.auth.header',
              "On deeptrue's workbenches you will find well-founded, ready-to-go insight tools"
            )}
          </Typography>
        }
        splashImage={signInSplash}
      >
        <CircularProgress />
      </SidePage>
    );
  }

  return (
    <SidePage
      title={t('pages.emailconfirm.title', 'Email confirmation')}
      slogan={
        <Typography color="white" variant="h4" mt="8rem">
          {t(
            'pages.auth.header',
            "On deeptrue's workbenches you will find well-founded, ready-to-go insight tools"
          )}
        </Typography>
      }
      splashImage={signInSplash}
    >
      {!isEmpty(error) ? (
        <FormHelperText error>{error}</FormHelperText>
      ) : (
        <h3>
          {t('pages.emailconfirm.success', 'Your email is confirmed now.')}
        </h3>
      )}
      <Grid
        container
        spacing={4}
        justify="center"
        style={{ paddingTop: '15px' }}
      >
        <Grid item xs={12}>
          <Button mt="1rem" width="100%" onClick={() => history.push('/')}>
            OK
          </Button>
        </Grid>
      </Grid>
    </SidePage>
  );
};

export default compose(
  withRouter,
  withMetaDescription({ title: 'Email Confirmation' })
)(EmailConfirm);
